import React from 'react';
import i18n from './../../../i18n';
import './LanguageToggle.scss';
//
class LanguageToggle extends React.Component {
	/**
     * 
     * @param {*} props 
     */
	constructor(props) {
		super(props);
		this.state = { lang: 'en' };
	}

	/**
     * 
     * @param {*} lang 
     */
	onClick(lang) {
		this.setState({ lang });
		i18n.changeLanguage(lang);
	}

	/**
     * 
     */
	render() {
		return (
			<div className="LanguageToggle">
				<div className="box">
					<div className={this.state.lang === 'en' ? 'buttonActive' : 'button'} onClick={this.onClick.bind(this, 'en')}>
						EN
					</div>
					<div className="divider">|</div>
					<div className={this.state.lang === 'nl' ? 'buttonActive' : 'button'} onClick={this.onClick.bind(this, 'nl')}>
						NL
					</div>
				</div>
			</div>
		);
	}
}

export default LanguageToggle;
